import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Footer component for drawers.
 * Typically contains action buttons.
 *
 * @example
 * ```html
 * <app-drawer-footer>
 *   <button mat-button (click)="cancel()">Cancelar</button>
 *   <button mat-flat-button color="primary" (click)="save()">Guardar</button>
 * </app-drawer-footer>
 * ```
 */
@Component({
  selector: 'app-drawer-footer',
  standalone: true,
  template: `
    <div class="drawer-footer">
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      .drawer-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 0.5rem;
        padding: 1rem 1.5rem;
        border-top: 1px solid rgba(0, 0, 0, 0.12);
        background: rgba(0, 0, 0, 0.02);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerFooterComponent {}
